module.exports = __webpack_public_path__ + "img/projects_global_harmonization.de82d67d.svg";